export default __webpack_public_path__ + "static/max-fcdba4507ce3a3c295e3fb81b54c23d4.webp";